import { Column, Table } from "@appkit4/react-components";
import { Link } from "react-router-dom";

const CookiesStatement = () => {
  const sectionA = [
    {
      id: 1,
      name: "userdetails",
      party: "First",
      duration: "Until user logout (session cookies)",
      description:
        "Stores user details (e.g. email address) for the logged in user",
      sharedWith: "PwC",
    },
    {
      id: 2,
      name: "path",
      party: "First",
      duration: "Until user logout (session cookies)",
      description: "Stores the application path",
      sharedWith: "PwC",
    },
    {
      id: 3,
      name: "OPENAMUSERDETAIL",
      party: "First",
      duration: "Until user logout (session cookies)",
      description: "Stores user details from openAM",
      sharedWith: "PwC",
    },
    {
      id: 4,
      name: "OPENAMSESSION",
      party: "First",
      duration: "Until user logout (session cookies)",
      description: "Checks the openAM session validity",
      sharedWith: "PwC",
    },
  ];

  const sectionB = [
    {
      id: 1,
      name: "_ga",
      party: "third",
      duration: "399 days",
      description: "Used to distinguish users",
    },
    {
      id: 2,
      name: "__cuid",
      party: "third",
      duration: "394 days",
      description:
        "Used to determine unique visitors to the site, and updated with each page view. Provided with a unique ID which is used to ensure the validity and accessibility of the cookie as an additional security measure.",
    },
  ];

  const sectionC = [
    {
      id: 1,
      name: "amp_fef1e8",
      party: "third",
      duration: "359 days",
      description:
        "This cookie supports Amplitude product analytics. The main purpose is Targeting/Advertising",
    },
  ];

  return (
    <div className="ap-container">
      <h2>Cookies Statement</h2>
      <h3>Introduction</h3>
      <p>
        The Corporate Interest Restriction Analyser (“CIRA”) is an application
        intended to be used to assist with the preparation of calculations and
        returns for the purposes of the UK Corporate Interest Restriction
        (“CIR”) rules. Authentication is based on PwC’s Authentication tool
        OpenAM for both internal and external users. There are four categories
        of user role – Admin, Supervisor, Editor and Reader.
      </p>

      <p>
        This information page is intended to provide users of the application
        with accessible, transparent information about the cookies used for the
        purposes of the CIRA application.
      </p>

      <p>
        This information is relevant to all users of CIRA. For more information
        about how we process your personal date collected through the
        application, please visit our &nbsp;
        <Link
          to="/privacy-statement"
          target="_blank"
          rel="noopener noreferrer"
          className="ap-link"
        >
          Privacy Statement
        </Link>
        .
      </p>

      <h3>Changes to this Cookie Policy</h3>
      <p>
        We recognise that transparency is an ongoing responsibility so our
        Cookie Policy is kept under regular review and this page will be updated
        to reflect any changes to the Policy.
      </p>

      <h3>What are Cookies?</h3>
      <p>
        Cookies are small text files that are placed on your computer by the
        Application when you visit. They are used in making CIRA work, or work
        more efficiently, as well as to provide statistical information to site
        owners. Even though some cookies enable the display of relevant
        advertising when you move from site to site, no advertisements, be it
        regular or targeted, are shown in the CIR Analyser application.{" "}
      </p>

      <h3>Our Cookies your Choice</h3>

      <p>This site utilises two types of Cookies:</p>

      <h5>Necessary Cookies</h5>
      <p>
        These cookies are necessary for CIRA to operate. The application cannot
        function without these cookies so they are always on.{" "}
      </p>

      <h5>Marketing Cookies</h5>
      <p>
        The tables below provide details about the types of Cookies used,
        including the duration of each cookie, its purpose and if its use
        involves the transfer of information to any of our third party business
        partners, which include openAM.
      </p>
      <p>These partners include openAM.</p>

      <h3>Section A: Strictly Necessary Cookies</h3>

      <Table originalData={sectionA} hasTitle striped>
        <Column field="name" sortKey="name">
          Cookie Name
        </Column>
        <Column field="party" sortKey="party">
          First or third party Cookie?
        </Column>
        <Column field="duration" sortKey="duration">
          Cookie Duration
        </Column>
        <Column field="description" sortKey="description">
          Cookie Purpose
        </Column>
        <Column field="sharedWith" sortKey="sharedWith">
          Information shared with
        </Column>
      </Table>

      <h3>Section B: Analytics Cookies</h3>

      <Table originalData={sectionB} hasTitle striped>
        <Column field="name" sortKey="name">
          Cookie Name
        </Column>
        <Column field="party" sortKey="party">
          First or third party Cookie?
        </Column>
        <Column field="duration" sortKey="duration">
          Cookie Duration
        </Column>
        <Column field="description" sortKey="description">
          Cookie Description
        </Column>
      </Table>

      <h3>Section C: Marketing Cookies</h3>

      <Table originalData={sectionC} hasTitle striped>
        <Column field="name" sortKey="name">
          Cookie Name
        </Column>
        <Column field="party" sortKey="party">
          First or third party Cookie?
        </Column>
        <Column field="duration" sortKey="duration">
          Cookie Duration
        </Column>
        <Column field="description" sortKey="description">
          Cookie Description
        </Column>
      </Table>

      <h3>Managing Cookies on your device</h3>
      <p>
        We use cookies to personalize content and to provide you with an
        improved user experience. You can control and manage cookies using your
        browser (see below). Please note that removing or blocking cookies can
        impact your user experience and some functionality may no longer be
        available.
      </p>
      <p>
        Necessary cookies are used to store user details for reference purposes.
        If those are deleted, the functionality of the Application may be
        affected. Marketing and analytics cookies are used by form io and are
        not used in our portal functionalities.
      </p>

      <h3>Using your browser to control Cookies</h3>
      <p>
        Most browsers allow you to view, manage, delete and block cookies for a
        website. Be aware that if you delete all cookies then any preferences
        you have set will be lost, including the ability to opt-out from cookies
        as this function itself requires placement of an opt out cookie on your
        device. Guidance on how to control cookies for common browsers is linked
        below.
      </p>

      <ul>
        <li>
          <a
            className="ap-link"
            href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Chrome
          </a>
        </li>
        <li>
          <a
            className="ap-link"
            href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mozilla Firefox
          </a>
        </li>
        <li>
          <a
            className="ap-link"
            href="https://support.apple.com/en-us/HT201265"
            target="_blank"
            rel="noopener noreferrer"
          >
            MacOS Safari
          </a>
        </li>
        <li>
          <a
            className="ap-link"
            href="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
            target="_blank"
            rel="noopener noreferrer"
          >
            Microsoft Internet Explorer
          </a>
        </li>
      </ul>

      <p>
        For information on additional browsers and device types please see
        &nbsp;
        <a
          className="ap-link"
          href="http://www.aboutcookies.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://www.aboutcookies.org/
        </a>
        &nbsp; or &nbsp;
        <a
          className="ap-link"
          href="http://www.cookiecentral.com/faq/"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://www.cookiecentral.com/faq/
        </a>
        .
      </p>
    </div>
  );
};

export default CookiesStatement;
